// Welches Produkt diese Instanz ist: Kanzlei (Elbcons: Mandanten-App, Kanzlei, Rechnungswerkzeug) oder Billtoro
// (das Rechnungswerkzeug allein für jede Firma). Der Server schreibt es in die index.html
// (<html data-produkt="billtoro">, app.ts), darum steht es schon fest, bevor die App startet: kein Laden, kein
// Aufblitzen der falschen Marke. Ohne Angabe ist es die Kanzlei, wie bisher.
export type Produkt = 'kanzlei' | 'billtoro';

export function produkt(): Produkt {
  return typeof document !== 'undefined' && document.documentElement.dataset.produkt === 'billtoro' ? 'billtoro' : 'kanzlei';
}

export function isBilltoro(): boolean {
  return produkt() === 'billtoro';
}

// Name der Marke für Seitentitel und Logo (aria-label)
export function markenName(): string {
  return isBilltoro() ? 'Billtoro' : 'Elbcons';
}
